export const initOpenTime = () => {
    if (!sessionStorage.getItem("homeViewerOpenTime")) {
      sessionStorage.setItem("homeViewerOpenTime", `${Date.now()}`);
    }
  };
  
  export const getOpenTime = () => {
    return parseInt(sessionStorage.getItem("homeViewerOpenTime") ?? "", 10);
  };
  
  export const getTimeSpent = () => {
    return Date.now() - getOpenTime();
  };
